(function () {
  // 1) Put your CDN MP4 URL here
  const VIDEO_URL = "https://cdn.shopify.com/videos/c/o/v/9a480ef584264ea49b9b1f741cda9db2.mov";

  function injectVideoIntoReadingTextSection(section) {
    const bg = section.querySelector(".image-background-fixed");
    if (!bg) return;

    // Prevent duplicates
    if (bg.querySelector("video.lt-reading-bg-video")) return;

    const video = document.createElement("video");
    video.className = "lt-reading-bg-video";
    video.autoplay = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = "metadata";

    const source = document.createElement("source");
    source.src = VIDEO_URL;
    source.type = "video/mp4";

    video.appendChild(source);
    bg.appendChild(video);

    // Try to start playback (some browsers may still block autoplay in edge cases)
    video.play().catch(() => {});
  }

  function run() {
    document
      .querySelectorAll(".shopify-section--reading-text")
      .forEach(injectVideoIntoReadingTextSection);
  }

  document.addEventListener("DOMContentLoaded", run);

  // If Shopify re-renders sections in the editor, run again
  document.addEventListener("shopify:section:load", (e) => {
    if (e.target && e.target.classList && e.target.classList.contains("shopify-section--reading-text")) {
      injectVideoIntoReadingTextSection(e.target);
    }
  });
})();
